import httpClientBase from "@geome/sdk/lib/http/client"
import { getOfferId } from "../../util/offers"

class HttpClient extends httpClientBase {
  post(path, data) {
    return this.request_with_offer_id("POST", path, data)
  }

  patch(path, data) {
    return this.request_with_offer_id("PATCH", path, data)
  }

  get(path, data) {
    if (data == null) {
      data = {}
    }
    return this.request_with_offer_id("GET", path, data)
  }

  offerId() {
    return getOfferId()
  }

  request_with_offer_id(method, path, data) {
    const offerId = this.offerId()
    if (offerId) {
      data.offer_id = offerId
    }
    return this.request(method, path, data)
  }
}

export default HttpClient
